/* Linsoul Journal: blog topic menu + article reading tools (contents, progress, save/share,
   [paginate] pages, [bento_gallery] lightbox). Strings come from [data-jr-config] / data attributes. */
(() => {
  'use strict';
  if (window.__lsJournal) return;
  window.__lsJournal = true;

  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const fill = (tpl, map) => String(tpl || '').replace(/\{(\w+)\}/g, (m, k) => (k in map ? map[k] : m));
  const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const SAVE_KEY = 'ls-journal-saved';

  function toast(text) {
    const node = $('.jr-toast');
    if (!node || !text) return;
    node.textContent = text;
    node.hidden = false;
    clearTimeout(node._t);
    node._t = setTimeout(() => { node.hidden = true; }, 2600);
  }

  function initTopics() {
    $$('[data-jr-topic-select]').forEach((select) => {
      select.addEventListener('change', () => { if (select.value) window.location.href = select.value; });
    });
  }

  function initActions() {
    const save = $('[data-jr-save]');
    const id = $('[data-jr-article]')?.dataset.jrArticle;
    if (save && id) {
      let saved = [];
      try { saved = JSON.parse(localStorage.getItem(SAVE_KEY) || '[]'); } catch (e) { saved = []; }
      const paint = () => {
        const on = saved.includes(id);
        save.setAttribute('aria-pressed', String(on));
        save.querySelector('span').textContent = on ? save.dataset.labelOn : save.dataset.label;
        save.querySelector('svg')?.classList.toggle('ls-i--filled', on);
      };
      paint();
      save.addEventListener('click', () => {
        const on = saved.includes(id);
        saved = on ? saved.filter((x) => x !== id) : saved.concat(id);
        try { localStorage.setItem(SAVE_KEY, JSON.stringify(saved)); } catch (e) { /* private mode */ }
        paint();
        toast(on ? save.dataset.toastOff : save.dataset.toast);
      });
    }
    const share = $('[data-jr-share]');
    if (share) {
      share.addEventListener('click', async () => {
        const data = { title: share.dataset.title, url: share.dataset.url || location.href };
        if (navigator.share) {
          try { await navigator.share(data); return; } catch (e) { if (e && e.name === 'AbortError') return; }
        }
        try { await navigator.clipboard.writeText(data.url); toast(share.dataset.toast); } catch (e) { window.prompt('', data.url); }
      });
    }
  }

  function slug(text, used) {
    let base = String(text).toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 60) || 'section';
    let out = base;
    let n = 2;
    while (used.has(out) || document.getElementById(out)) out = `${base}-${n++}`;
    used.add(out);
    return out;
  }

  function initArticle(root) {
    let cfg = {};
    try { cfg = JSON.parse($('[data-jr-config]', root)?.textContent || '{}'); } catch (e) { cfg = {}; }
    const content = $('[data-jr-content]', root);
    if (!content) return;

    const file = (src) => (src || '').split('?')[0].split('/').pop().replace(/_\d+x\d*(?=\.)/, '').replace(/_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}(?=\.)/i, '');
    const hero = $('.jr-article-visual img');
    const lead = content.firstElementChild;
    const leadImg = lead && (lead.matches('img') ? lead : lead.matches('p, div, figure') && lead.children.length === 1 && !lead.textContent.trim() ? $('img', lead) : null);
    if (hero && leadImg && file(hero.currentSrc || hero.src) === file(leadImg.getAttribute('src'))) lead.hidden = true;

    content.querySelectorAll('table').forEach((table) => {
      if (table.closest('.sc-table-scroll, .jr-table-scroll')) return;
      const wrap = document.createElement('div');
      wrap.className = 'jr-table-scroll';
      table.before(wrap);
      wrap.append(table);
    });

    const pager = initPages(root, content, cfg);
    initContents(root, content, cfg, pager);
    initGallery(root, cfg);
  }

  function initContents(root, content, cfg, pager) {
    const rail = $('[data-jr-rail]', root);
    const toc = $('[data-jr-toc]', root);
    const mobileBar = $('[data-jr-mobile-bar]', root);
    const mobileToc = $('[data-jr-mobile-toc]', root);
    const progressBar = $('[data-jr-progress]', root);
    const progressText = [$('[data-jr-progress-label]', root), $('[data-jr-mobile-progress]', root)].filter(Boolean);
    const layout = $('[data-jr-layout]', root);
    const min = Number(cfg.minHeadings) || 3;

    const own = (tag) => $$(tag, content).filter((h) => h.textContent.trim() && !h.closest('.sc-comparison, .sc-bento, .sc-mini-hero, .sc-fr, .sc-icon-section, .sc-award, .jr-table-scroll'));
    const level = ['h2', 'h3', 'h1'].find((tag) => own(tag).length >= min);
    const headings = level ? own(level) : [];

    if (toc && headings.length >= min) {
      const used = new Set();
      const links = headings.map((h) => {
        if (!h.id) h.id = slug(h.textContent.trim(), used);
        h.classList.add('jr-anchor');
        const a = document.createElement('a');
        a.href = `#${h.id}`;
        a.textContent = h.textContent.trim().replace(/\s+/g, ' ');
        return a;
      });
      links.forEach((a) => toc.append(a));
      if (mobileToc) links.forEach((a) => mobileToc.append(a.cloneNode(true)));
      rail.hidden = false;
      if (mobileBar) mobileBar.hidden = false;

      const byId = new Map(links.map((a) => [a.hash.slice(1), a]));
      const visible = new Set();
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => (e.isIntersecting ? visible.add(e.target) : visible.delete(e.target)));
        let current = null;
        for (const h of headings) {
          if (h.getBoundingClientRect().top < window.innerHeight * 0.35) current = h;
        }
        links.forEach((a) => a.removeAttribute('aria-current'));
        if (current) byId.get(current.id)?.setAttribute('aria-current', 'location');
      }, { rootMargin: '0px 0px -60% 0px' });
      headings.forEach((h) => io.observe(h));

      const dialog = $('.jr-toc-dialog', root);
      $('[data-jr-open-toc]', root)?.addEventListener('click', () => dialog?.showModal());
      $('[data-jr-close-toc]', root)?.addEventListener('click', () => dialog?.close());
      dialog?.addEventListener('click', (e) => {
        if (e.target === dialog) dialog.close();
        if (e.target.closest('a')) dialog.close();
      });
      [toc, mobileToc].forEach((nav) => nav?.addEventListener('click', (e) => {
        const a = e.target.closest('a[href^="#"]');
        if (!a || !pager) return;
        const target = document.getElementById(a.hash.slice(1));
        if (target) pager.reveal(target);
      }));
    } else {
      layout?.classList.add('jr-no-toc');
      rail?.remove();
      mobileBar?.remove();
    }

    const update = () => {
      const r = content.getBoundingClientRect();
      const total = Math.max(1, r.height - window.innerHeight * 0.6);
      const done = Math.min(1, Math.max(0, -r.top / total));
      if (progressBar) progressBar.style.transform = `scaleX(${done})`;
      const label = fill(cfg.progress, { n: Math.round(done * 100) });
      progressText.forEach((n) => { n.textContent = label; });
    };
    let ticking = false;
    window.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => { ticking = false; update(); });
    }, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  }

  function initPages(root, content, cfg) {
    const breaks = Array.from(content.children).filter((n) => n.hasAttribute('data-article-pagebreak'));
    $$('[data-article-pagination]', content).forEach((n) => n.remove());
    if (!breaks.length) return null;

    const nodes = Array.from(content.childNodes);
    const pages = [];
    const newPage = (title) => {
      const page = document.createElement('section');
      page.className = 'sc-page';
      page.dataset.articlePage = String(pages.length + 1);
      page.setAttribute('aria-label', title || fill(cfg.pageN, { n: pages.length + 1 }));
      pages.push(page);
      return page;
    };
    let page = newPage('');
    nodes.forEach((node) => {
      if (node.nodeType === 1 && node.hasAttribute('data-article-pagebreak')) {
        page = newPage(node.dataset.pageTitle);
        if (node.dataset.pageTitle) {
          const h = document.createElement('h2');
          h.className = 'jr-page-title';
          h.textContent = node.dataset.pageTitle;
          page.append(h);
        }
        node.remove();
      } else {
        page.append(node);
      }
    });
    pages.forEach((p) => content.append(p));

    const nav = document.createElement('nav');
    nav.className = 'sc-pagination';
    nav.setAttribute('aria-label', cfg.pagesLabel || '');
    content.after(nav);

    let active = 1;
    const start = Number(new URLSearchParams(location.search).get('article_page'));
    if (start >= 1 && start <= pages.length) active = start;

    const button = (label, go, disabled, current) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.textContent = label;
      b.dataset.go = String(go);
      b.disabled = !!disabled;
      if (current) b.setAttribute('aria-current', 'page');
      nav.append(b);
    };
    const render = (focus) => {
      const all = active === 'all';
      pages.forEach((p, i) => { p.hidden = !all && i + 1 !== active; });
      nav.textContent = '';
      button(cfg.prev, all ? 1 : active - 1, all || active === 1, false);
      pages.forEach((p, i) => button(String(i + 1), i + 1, false, !all && i + 1 === active));
      button(cfg.next, all ? pages.length : active + 1, all || active === pages.length, false);
      button(all ? cfg.paged : cfg.all, all ? 1 : 'all', false, false);
      const status = document.createElement('span');
      status.className = 'sc-page-status';
      status.setAttribute('aria-live', 'polite');
      status.textContent = all ? cfg.allStatus : fill(cfg.pageStatus, { n: active, total: pages.length });
      nav.append(status);
      try {
        const u = new URL(location.href);
        u.searchParams.set('article_page', String(active));
        history.replaceState(history.state, '', u);
      } catch (e) { /* ignore */ }
      if (focus) {
        const target = all ? pages[0] : pages[active - 1];
        const h = target.querySelector('h1, h2, h3') || target;
        h.setAttribute('tabindex', '-1');
        h.focus({ preventScroll: true });
        root.scrollIntoView({ block: 'start', behavior: reduced() ? 'auto' : 'smooth' });
      }
    };
    nav.addEventListener('click', (e) => {
      const b = e.target.closest('button[data-go]');
      if (!b || b.disabled) return;
      active = b.dataset.go === 'all' ? 'all' : Number(b.dataset.go);
      render(true);
    });
    render(false);
    return {
      reveal(target) {
        const p = target.closest('[data-article-page]');
        if (p && p.hidden) { active = Number(p.dataset.articlePage); render(false); }
      },
    };
  }

  function initGallery(root, cfg) {
    const dialog = $('[data-jr-lightbox]', root);
    if (!dialog) return;
    const img = $('[data-jr-lightbox-img]', dialog);
    const title = $('[data-jr-lightbox-title]', dialog);
    const count = $('[data-jr-lightbox-count]', dialog);
    let items = [];
    let index = 0;
    let opener = null;
    const show = () => {
      const a = items[index];
      img.src = a.href;
      img.alt = a.querySelector('img')?.alt || '';
      count.textContent = fill(cfg.counter, { n: index + 1, total: items.length });
    };
    root.addEventListener('click', (e) => {
      const a = e.target.closest('[data-jr-gallery-item]');
      if (!a || e.metaKey || e.ctrlKey || e.shiftKey) return;
      const gallery = a.closest('[data-jr-gallery]');
      e.preventDefault();
      items = $$('[data-jr-gallery-item]', gallery);
      index = items.indexOf(a);
      title.textContent = gallery.dataset.title || '';
      opener = a;
      show();
      dialog.showModal();
    });
    $$('[data-jr-lightbox-step]', dialog).forEach((b) => b.addEventListener('click', () => {
      index = (index + Number(b.dataset.jrLightboxStep) + items.length) % items.length;
      show();
    }));
    $('[data-jr-lightbox-close]', dialog)?.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (e) => { if (e.target === dialog) dialog.close(); });
    dialog.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
        index = (index + (e.key === 'ArrowRight' ? 1 : -1) + items.length) % items.length;
        show();
      }
    });
    dialog.addEventListener('close', () => opener?.focus());
  }

  const init = () => {
    initTopics();
    initActions();
    $$('[data-jr-body]').forEach((root) => {
      if (root.dataset.jrReady) return;
      root.dataset.jrReady = '1';
      initArticle(root);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', () => {
    $$('[data-jr-body]').forEach((root) => { if (!root.dataset.jrReady) { root.dataset.jrReady = '1'; initArticle(root); } });
  });
})();
